import { useFormContext, Controller } from 'react-hook-form'
import { Input } from '@cb/apricot-react'
import { CBInputMethod } from '@cb/apricot'
import { FIELD_NICKNAME } from '../constants'
import { validateNickname, validateFieldState } from '../validations'

function Nickname({ disabled }) {
  const { control } = useFormContext()

  useEffect(() => {
    CBInputMethod()
  }, [])

  return (
    <Controller
      control={control}
      name={FIELD_NICKNAME}
      rules={{
        validate: value => validateNickname(value),
      }}
      disabled={disabled}
      render={({
        field: { onChange, onBlur, value, disabled, name },
        fieldState: { invalid, isDirty, isTouched, error },
      }) => (
        <Input
          name={name}
          label="Nickname"
          value={value}
          onChange={value => onChange(value)}
          onBlur={value => onBlur(value)}
          floating={false}
          autoComplete="off"
          maxLength="15"
          disabled={disabled}
          validation={validateFieldState({ invalid, isDirty, isTouched, error, value })}
          validationMsg={error?.message}
        />
      )}
    />
  )
}

export default Nickname
